/**
 * Shot Store — shot launcher state
 */
import { createStore } from 'zustand/vanilla';
import type { Shot, ShotItem } from '@graphicsim/shared-types';
import { eventBus } from '../engine/eventBus';

let nextShotNum = 1;

export interface ShotState {
  shots: Shot[];
  selectedShotId: string | null;
  zoomLevel: number; // 0-1
  // Actions
  addShot: (name: string, items: ShotItem[]) => Shot;
  removeShot: (shotId: string) => void;
  selectShot: (shotId: string | null) => void;
  triggerShot: (shotId: string) => void;
  setZoom: (level: number) => void;
  updateShot: (shotId: string, updates: Partial<Shot>) => void;
}

export const shotStore = createStore<ShotState>((set, get) => ({
  shots: [],
  selectedShotId: null,
  zoomLevel: 0.5,

  addShot: (name, items) => {
    const shot: Shot = {
      id: `shot-${Date.now()}-${nextShotNum++}`,
      name,
      items,
    };
    set({ shots: [...get().shots, shot] });
    eventBus.emit('shot:created', { shot });
    return shot;
  },

  removeShot: (shotId) => {
    set({ shots: get().shots.filter((s) => s.id !== shotId) });
    if (get().selectedShotId === shotId) set({ selectedShotId: null });
    eventBus.emit('shot:removed', { shotId });
  },

  selectShot: (shotId) => set({ selectedShotId: shotId }),

  triggerShot: (shotId) => {
    eventBus.emit('shot:triggered', { shotId });
  },

  setZoom: (level) => set({ zoomLevel: Math.max(0, Math.min(1, level)) }),

  updateShot: (shotId, updates) => {
    set({
      shots: get().shots.map((s) => (s.id === shotId ? { ...s, ...updates } : s)),
    });
  },
}));
